import EmptyDashboard from './EmptyDashboard.js';

export default EmptyDashboard;
